const SvgIcon = ({size = 24, color = "#000"}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg847"
    width={''+size}
    height={''+size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path845"
      fill={color}
      fillRule="evenodd"
      strokeWidth="1"
      d="M5.61 10.667 16.275 0l2.667 2.666L9.609 12l9.334 9.334L16.276 24 5.61 13.333a1.886 1.886 0 0 1 0-2.666"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default SvgIcon;
